import React, { useState } from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Popover } from '@mui/material';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { useUserRolePermissions } from 'hooks';

import { styled } from '@mui/material/styles';
// Components
import FilterPopover from '../filter-popover/FilterPopover.connector';

// eslint-disable-next-line no-undef
const FilterCounter = styled(`span`)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 12,
  height: 16,
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  padding: 2,
  width: 14,
}));

const newButtonStyles = {
  marginRight: theme => ({
    // TODO: Migrate to the new breakpoints
    xs: theme.spacing(3.5),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    md: 0,
  }),
};
const filtersButtonStyles = { marginRight: theme => theme.spacing(1) };

const DesktopButtons = props => {
  const {
    filterCount,
    filterOptions,
    handleClickViewClosed,
    handleClickViewList,
    onCreateNew,
    openPtoList,
    numberFuturePtos,
  } = props;

  const disableFilterButton =
    !openPtoList.length ||
    (filterOptions?.locations.length <= 2 &&
      numberFuturePtos === 0 &&
      filterOptions?.affiliateListDropdown.length <= 2 &&
      filterOptions?.dataCompanyOptions.length <= 2 &&
      filterOptions?.originatorOptions.length <= 2 &&
      filterOptions?.recipientOptions.length <= 2 &&
      filterOptions?.transferDates.length <= 2);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const { isProductOwnerManage, isInventoryOwner } = useUserRolePermissions();

  const handleFilterClick = event => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setFilterAnchorEl(null);
  };

  const filterOpen = Boolean(filterAnchorEl);

  return (
    <>
      <Link onClick={() => handleClickViewList()} style={{ textDecoration: 'none' }} to="../search">
        <Button className="css-heap-redact" variant="text">
          View List
        </Button>
      </Link>
      <Link
        onClick={() => handleClickViewClosed()}
        style={{ textDecoration: 'none' }}
        to="../search"
      >
        <Button className="css-heap-redact" variant="text">
          View Closed
        </Button>
      </Link>
      <>
        <Button
          className="css-heap-redact"
          disabled={disableFilterButton}
          onClick={handleFilterClick}
          onClose={handleClose}
          sx={filtersButtonStyles}
          variant="text"
        >
          Filters
          {filterCount >= 1 && <FilterCounter>{filterCount}</FilterCounter>}
          {filterOpen ? (
            <ExpandLessRoundedIcon position="right" variant="buttonsChild" />
          ) : (
            <ExpandMoreRoundedIcon position="right" variant="buttonsChild" />
          )}
        </Button>

        <Popover
          anchorEl={filterAnchorEl}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          disableScrollLock
          onClose={handleClose}
          open={filterOpen}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
        >
          <FilterPopover handleClose={handleClose} />
        </Popover>
      </>
      {isProductOwnerManage && isInventoryOwner && (
        <Button className="css-heap-redact" onClick={onCreateNew} sx={newButtonStyles}>
          New Order
        </Button>
      )}
    </>
  );
};

DesktopButtons.propTypes = {
  filterCount: number.isRequired,
  filterOptions: shape({
    affiliateListDropdown: arrayOf(shape({})).isRequired,
    dataCompanyOptions: arrayOf(shape({})).isRequired,
    locations: arrayOf(shape({})).isRequired,
    originatorOptions: arrayOf(shape({})).isRequired,
    recipientOptions: arrayOf(shape({})).isRequired,
    transferDates: arrayOf(shape({})).isRequired,
  }).isRequired,
  handleClickViewClosed: func.isRequired,
  handleClickViewList: func.isRequired,
  numberFuturePtos: number.isRequired,
  onCreateNew: func.isRequired,
  openPtoList: arrayOf(
    oneOfType([
      shape({
        locations: string,
      }),
      shape({
        locations: string,
      }),
    ])
  ),
};

DesktopButtons.defaultProps = {
  openPtoList: null,
};
// taylor - test navigate and other hooks still work
export default DesktopButtons;
